import send from '../../utils/fetch'

const fData = {
    geo_id: 0,
    start: 0,
    end: 0,
    is_active: 0,
    asc: 0,
    desc: 0,
    timing: 0
}

const state = {
    holds: []
}

const actions = {
    async GET_HOLDS({ commit, getters }) {
        try {
            const lists = []
            let {data} = await send(global.$url.hold.get, 'GET')

            const geos = getters.geo.geos

            for (const geo of geos) {
                lists.push({geo: geo.id, geo_name: geo.name})
            }

            for (const list of lists) {
                if (data.result.length || Object.keys(data.result).length) {
                    for (const key in data.result) {
                        if (data.result[list.geo]) {
                            Object.assign(list, data.result[list.geo][0])
                        } else {
                            Object.assign(list, fData)
                        }
                    }
                } else {
                    Object.assign(list, fData)
                }
            }

            data.result = lists
            commit('SET_HOLDS', data.result)
            return data
        } catch (e) {}
    },

    async CREATE_HOLD({ dispatch }, hold) {
        try {
            const {data} = await send(global.$url.hold.create, 'POST', {data: hold})
            dispatch('GET_HOLDS')
            return data
        } catch (e) {}
    },

    async EDIT_HOLD({ dispatch }, hold) {
        try {
            const {data} = await send(global.$url.hold.update, 'PUT', {data: hold})
            dispatch('GET_HOLDS')
            return data
        } catch (e) {}
    },

    async UPDATE_STATUS_HOLD({ dispatch }, id) {
        try {
            const {data} = await send(global.$url.hold.destroy, 'DELETE', {data: id})
            dispatch('GET_HOLDS')
            return data
        } catch (e) {}
    }
}

const mutations = {
    SET_HOLDS(state, data) {
        state.holds = data
    }
}

const getters = {
    holds: state => state.holds
}

export default {
    state,
    actions,
    mutations,
    getters
}
